module.exports = __webpack_public_path__ + "img/point.13d7fc9b.svg";